var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      [
        _vm.ocrTab === _vm.OCR_TAB_IDENTIFY.code
          ? _c("span", { staticStyle: { margin: "7px", width: "80px" } }, [
              _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_IdentificationType")))
            ])
          : _vm._e(),
        _vm.ocrTab === _vm.OCR_TAB_IDENTIFY.code
          ? _c(
              "el-select",
              {
                staticStyle: { width: "150px" },
                attrs: { no: "1" },
                on: {
                  input: function(val) {
                    return _vm.handleSearch("select", val)
                  }
                },
                model: {
                  value: _vm.searchConditions.identificationType,
                  callback: function($$v) {
                    _vm.$set(_vm.searchConditions, "identificationType", $$v)
                  },
                  expression: "searchConditions.identificationType"
                }
              },
              _vm._l(_vm.typeList, function(item, index) {
                return _c("el-option", {
                  key: index,
                  attrs: { label: _vm.$getLangColumn(item), value: item.code }
                })
              }),
              1
            )
          : _vm._e(),
        _vm.ocrTab !== _vm.OCR_TAB_IDENTIFY.code
          ? _c(
              "search-item",
              {
                attrs: {
                  "config-module": _vm.configModule,
                  "show-simple": false,
                  "expand-adv": true
                },
                on: { advSearchItemCallBack: _vm.toQuery }
              },
              [
                _c(
                  "template",
                  { slot: "operations" },
                  [
                    _vm.ocrTab === _vm.OCR_TAB_PENDING.code
                      ? _c(
                          "el-dropdown",
                          {
                            staticStyle: {
                              margin: "0 5px",
                              "font-size": "12px"
                            },
                            attrs: { no: "batchHandle" },
                            on: { command: _vm.batchHandle }
                          },
                          [
                            _c("el-button", { attrs: { type: "primary" } }, [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$t("SeaExport.BatchProcessing")) +
                                  " "
                              ),
                              _c("i", {
                                staticClass: "el-icon-arrow-down el-icon--right"
                              })
                            ]),
                            _c(
                              "el-dropdown-menu",
                              { attrs: { slot: "dropdown" }, slot: "dropdown" },
                              [
                                _c(
                                  "el-dropdown-item",
                                  { attrs: { command: 1 } },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("CargoMsg.Cargo_BatchDelete")
                                      ) + " "
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.ocrTab === _vm.OCR_TAB_PENDING.code &&
                    _vm.$checkPermission([
                      "button_ocrRecognition_supplementaryInformation"
                    ])
                      ? _c(
                          "el-button",
                          {
                            staticStyle: { width: "120px" },
                            attrs: { type: "primary" },
                            on: {
                              click: function() {
                                return _vm.$emit("supplementaryInformation")
                              }
                            }
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "CargoMsg.Cargo_SupplementaryInformation"
                                )
                              )
                            )
                          ]
                        )
                      : _vm._e()
                  ],
                  1
                )
              ],
              2
            )
          : _vm._e()
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }